import { ospreyAPI } from '@repo/api/ospreyAPI'
import { storeWrapper } from '../storeWrapper'
import { debounce } from '@repo/utils/debounce'

const initialState = {
  isAuthenticated: false,
  isAuthenticating: false,
  error: null
}

export const useDocumentBundleAuthStore = storeWrapper('useDocumentBundleAuthStore', (set) => ({
  ...initialState,
  updateState: ({ key, value }) => {
    set({ [key]: value })
  },
  IsAuthenticatedUser: async () => {
    const result = await ospreyAPI({
      method: 'GET',
      service: 'documents',
      endpoint: 'Bundledocs/IsAuthenticated'
    })
    return result === true
  },
  getLoginUrl: ({ clientNo, matterNo }) => {
    return new Promise((resolve) => {
      set({
        loading: true
      })

      debounce({
        id: `bundledocs-login-${clientNo}-${matterNo}`,
        delay: 300,
        callback: async () => {
          try {
            const loginUrl = await ospreyAPI({
              method: 'GET',
              service: 'documents',
              endpoint: 'Bundledocs/GetLoginUrl'
            })

            resolve(loginUrl)
          } catch (error) {
            console.error('Failed to fetch BundleDocs login URL', error)
            resolve(null)
          } finally {
            set({
              loading: false
            })
          }
        }
      })
    })
  },

  reset: () => set(initialState)
}))
